module.exports = __webpack_public_path__ + "static/media/refresh.a317b66a.png";